export const IS_SPLASH_VISITED = 'IS_SPLASH_VISITED';
